import {
  useGetPasscodeMutation,
  useResetPasscodeMutation,
} from "../store/services/passcodeQuery";

export const usePasscode = () => {
  const [
    getPasscode,
    {
      data: passcodeData,
      isLoading: passcodeIsLoading,
      isError: passcodeIsError,
      error: passcodeError,
      isSuccess: passcodeIsSuccess,
    },
  ] = useGetPasscodeMutation();

  const [
    resetPassword,
    {
      data: resetPasswordData,
      isLoading: resetPasswordIsLoading,
      isError: resetPasswordIsError,
      error: resetPasswordError,
      isSuccess: resetPasswordSuccess,
    },
  ] = useResetPasscodeMutation();

  return {
    getPasscode,
    passcodeData,
    passcodeIsLoading,
    passcodeIsError,
    passcodeError,
    passcodeIsSuccess,
    resetPassword,
    resetPasswordData,
    resetPasswordIsLoading,
    resetPasswordIsError,
    resetPasswordError,
    resetPasswordSuccess,
  };
};
